import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';

export default class MyAccount extends AuthRoute {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      plinko: true,
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      MyAccountLogo: {
        y: 339,
        x: 462,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('/images/settings-icons/my-account.svg'),
          103,
          124
        ),
      },
      MyAccountTitle: {
        y: 511,
        x: 374,
        w: 300,
        text: {
          text: 'My Account',
          fontFace: 'OpenSans-Regular',
          fontSize: 52,
          textColor: Colors('#fafafa').get(),
        },
      },
      MyAccountInfo: {
        type: Column,
        plinko: true,
      },
    };
  }

  get _MyAccountInfo() {
    return this.tag('MyAccountInfo');
  }
}
